/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import { isEmpty } from 'serenova-js-utils/strings';

export const formValidation = (values, props) => {
  const minPriorityValue = values.get('minPriority');
  const maxPriorityValue = values.get('maxPriority');
  const priorityValue = values.get('priorityValue');
  const priorityRate = values.get('priorityRate');

  const PriorityFieldValidation = {
    minPriority: () => {
      if (!minPriorityValue) {
        return minPriorityValue === 0
          ? 'The minimum priority must be greater than 0'
          : 'Please enter a minimum priority';
      } else if (minPriorityValue > maxPriorityValue) {
        return 'The minimum priority cannot be greater than the maximum priority';
      }
    },
    maxPriority: () => {
      if (!maxPriorityValue) {
        return maxPriorityValue === 0
          ? 'The maximum priority must be greater than 0'
          : 'Please enter a maximum priority';
      } else if (maxPriorityValue < minPriorityValue) {
        return 'The maximum priority cannot be less than the minimum priority';
      } else if (maxPriorityValue > 1000) {
        return 'The maximum priority cannot be greater than 1000';
      }
    },
    priorityValue: () => {
      if (!priorityValue) {
        return priorityValue === 0 ? 'The priority value must be greater than 0' : 'Please enter a priority value';
      } else if (priorityValue > 1000) {
        return 'The priority value cannot be greater than 1000';
      }
    },
    priorityRate: () => {
      if (!priorityRate) {
        return priorityRate === 0 ? 'The priority rate must be greater than 0' : 'Please enter a priority rate';
      }
    },
    priorityUnit: isEmpty(values.get('priorityUnit')) && 'Please select a priority unit',
    slaId: isEmpty(values.get('slaId')) && 'Please choose a sla',
  };

  const queueQueryCreateValidation = {
    basicQuery: isEmpty(values.get('basicQuery')) && '',
    minPriority: PriorityFieldValidation.minPriority(),
    maxPriority: PriorityFieldValidation.maxPriority(),
    priorityValue: PriorityFieldValidation.priorityValue(),
    priorityRate: PriorityFieldValidation.priorityRate(),
    priorityUnit: PriorityFieldValidation.priorityUnit,
    slaId: PriorityFieldValidation.slaId,
  };

  if (props.selectedEntityId === 'create') {
    return {
      name: isEmpty(values.get('name')) && 'Please enter a name',
      ...queueQueryCreateValidation,
    };
  } else {
    if (props.selectedSubEntityId) {
      return queueQueryCreateValidation;
    } else {
      return {
        name: isEmpty(values.get('name')) && 'Please enter a name',
        activeVersion: isEmpty(values.get('activeVersion')) && 'Please select an active queue version',
      };
    }
  }
};
